import {onUnmounted} from '@vue/composition-api'

/**
 * Listens to window resize while the component is mounted.
 */
export default function useWindowResize (callback) {
  window.addEventListener('resize', callback)
  onUnmounted(() => {
    window.removeEventListener('resize', callback)
  })
}
